import ConfigureGame from './ConfigureGame'
export default ConfigureGame
